import * as React from "react";
import { useLocation } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import { SideNav } from "./side-nav";

// ── Mobile / tablet menu (below the lg breakpoint) ──────────────────────
// This used to be a separate copy of the sidebar with its own module list,
// theme and logic, so it kept falling behind the desktop sidebar. It now
// renders the SAME <SideNav /> (variant="drawer") inside a slide-out drawer —
// one sidebar for every screen size: same modules, sub-modules, icons,
// cream/gold theme, profile card and logout.
export function MobileNav({ open, onClose }) {
  const { pathname } = useLocation();

  // Close the drawer whenever the page changes (back/forward included).
  const lastPath = React.useRef(pathname);
  React.useEffect(() => {
    if (lastPath.current !== pathname) {
      lastPath.current = pathname;
      if (open) onClose?.();
    }
  }, [pathname, open, onClose]);

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "85vw", sm: 300 },
          maxWidth: 300,
          height: "100%",
          overflow: "hidden",
          borderRight: "1px solid #e6dfd0",
          boxShadow: "6px 0 28px rgba(31,36,48,0.18)",
        },
      }}
    >
      <SideNav variant="drawer" onClose={onClose} />
    </Drawer>
  );
}
